import React from 'react';
import Table from '../../../views/StyledTable';
import DateFormatter from '../../../utils/DateFormatter';
import Ellipsed from '../../../views/Ellipsed';


export const showCatAsList = function (text, mode) {
  let output = '',
      outArray = [];

  if(typeof mode === "object") {
    for (const cat in text) output += `${text[cat]}, `;
    output = output.slice(0, -2);
    return <Ellipsed width={400}>{output}</Ellipsed>;
  } else {
    for (const cat in text) {
      outArray.push(<a href={'/categories/drilldown/' + text[cat]}>{text[cat]}</a>);
      outArray.push(', ');
    }
    outArray.pop();
    return <div>{outArray}</div>;
  }
};

export const formatDate = function (text) {
  const output = DateFormatter.formatUtcShort(text);
  return React.createElement('span', {}, output);
};

const detailColumns = [
  {
    title: 'ID',
    dataIndex: 'id',
  },
  {
    title: 'Status',
    width: '80px',
    dataIndex: 'jobStatus',
  },
  {
    title: 'Date',
    dataIndex: 'dateBegin',
    width: '120px',
    render: formatDate,
  },
];

class DataTable extends React.Component {
  constructor(props) {
    super(props);
    this.showDetailPanel = this.showDetailPanel.bind(this);
  }

  showDetailPanel(record) {
    this.props.setShowDetail(record.id);
    this.props.setColumns(detailColumns);
  }

  render() {
    const tableHeight = this.props.pageHeight - 240;
    return (
      <div>
        <Table
          rowKey="id"
          pagination={{ pageSize: 50 }}
          size="small"
          columns={this.props.columns}
          loading={this.props.loading}
          dataSource={this.props.jobs}
          onRow={record => ({
                        onClick: () => this.showDetailPanel(record),
                    })}
          scroll={{ y: tableHeight }}
        />
      </div>
    );
  }
}

export default DataTable;
